import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./ContactPage.css";
import heartLineImg from "../assets/images/heartLineImg.png";
import smallHeartImg from "../assets/images/smallHeartImg.png";
import emailImg from "../assets/images/emailImg.png";
import instagramImg from "../assets/images/instagramImg.png";
import messengerImg from "../assets/images/messengerImg.png";
import clockImg from "../assets/images/clockImg.png";
import SEO from "../components/SEO";
import contactImg from "../assets/images/contHeroBanerImg.png"

const CHANNELS = [
  {
    image: emailImg,
    label: "Email",
    value: "zori.place1@gmail.com",
    desc: "Ми відповідаємо протягом 24 годин у робочі дні.",
  },
  {
    image: instagramImg,
    label: "Instagram",
    value: "zori.place.stickers",
    desc: "Пишіть нам у Direct — відповідаємо швидко!",
  },
  {
    image: messengerImg,
    label: "Месенджер",
    value: "+380933406560",
    desc: "Напишіть нам у Вайбер або Телеграм",
  },
  {
    image: clockImg,
    label: "Графік роботи",
    value: "Пн – Пт: 9:00–18:00",
    desc: "Сб – Нд: вихідні",
  },
];

const FAQS = [
  { q: "Як швидко ви відповідаєте?", a: `Ми відповідаємо протягом години в робочі години.
 У вихідні дні також опрацьовуємо всі запити в штатному режимі.` },
  {
    q: "Де знаходиться моя посилка?",
    a: `Після оформлення замовлення менеджер надає попередній трек-номер.
 Після відправки він активується та відображає весь шлях посилки.
 Відстежити замовлення можна у додатку або на сайті перевізника.`,
  },
  {
    q: "Чи можна змінити або скасувати замовлення?",
    a: `Змінити або скасувати замовлення можна на етапі його оформлення.
 Повернення або обмін можливі протягом 14 днів згідно законодавства України.
Зверніть увагу:
 товари, виготовлені за індивідуальними параметрами (з ініціалами або зміненими кольорами), поверненню та обміну не підлягають.`,
  },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", topic: "", message: "" });
  const [sent, setSent] = useState(false);
  const [openFaq, setOpenFaq] = useState(-1);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("🔥 FORM:", form);
      await axios.post("/api/contact", form);

      setSent(true);
    } catch (error) {
      console.error(error);
      alert("Помилка відправки");
    }
  };

  return (
    <div className="contact-page page-enter">
      <SEO
        title="Контакти "
        description="Контакти, як з нами зв'язатися, графік роботи, часті запитання."
        url="https://zori.place/contact"
      />
      {/* Hero */}
      <section className="contact-hero">
	<img src={contactImg} alt="contact background" fetchpriority="high" decoding="async" className="hero-bg" />        
<div className="container contact-hero-inner">
          <div>
            <h1 className="contact-hero-title">Контакти</h1>
            <img src={heartLineImg} alt="підкресленя" className="delivery-hero-accent" />
            <p className="contact-hero-desc">
              Ми завжди на зв'язку та раді відповісти на ваші запитання{" "}
            </p>
          </div>
        </div>
      </section>

      {/* Channels */}
      <section className="contact-channels">
        <div className="container">
          <h3>ЯК З НАМИ ЗВ'ЯЗАТИСЯ</h3>
          <div className="contact-channels-grid">
            {CHANNELS.map((c) => (
              <div key={c.label} className="contact-channel-card">
                <div className="channel-icon">
                  <img src={c.image} alt={c.label} />
                </div>
                <strong>{c.label}</strong>
                <span className="channel-value">{c.value}</span>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form + CTA side by side */}
      <section className="contact-form-section">
        <div className="container">
          <div className="contact-form-grid">
            <div className="contact-form-block">
              <h3>НАПИШІТЬ НАМ</h3>
              <p className="form-desc">Заповніть форму, і ми зв'яжемося з вами якомога швидше.</p>

              {sent ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                  <div style={{ fontSize: "2.5rem", marginBottom: 16 }}>✅</div>
                  <h3 style={{ color: "var(--deep-brown)", marginBottom: 8 }}>
                    Повідомлення надіслано!
                  </h3>
                  <p style={{ color: "var(--text-light)", marginBottom: 24, fontSize: "0.9rem" }}>
                    Ми відповімо найближчим часом.
                  </p>
                  <button
                    className="btn-outline"
                    onClick={() => {
                      setSent(false);
                      setForm({ name: "", email: "", topic: "", message: "" });
                    }}
                  >
                    Надіслати ще одне
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Ваше ім'я</label>
                      <input
                        name="name"
                        type="text"
                        placeholder="Ваше ім'я"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Тема повідомлення</label>
                    <input
                      name="topic"
                      type="text"
                      placeholder="Тема повідомлення"
                      value={form.topic}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Ваше повідомлення</label>
                    <textarea
                      name="message"
                      placeholder="Ваше повідомлення..."
                      value={form.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <button type="submit" className="btn-primary" style={{ width: "100%" }}>
                    НАДІСЛАТИ ПОВІДОМЛЕННЯ
                  </button>
                </form>
              )}
            </div>

            <div>
              <div className="contact-cta-box">
                <img src={smallHeartImg} alt="small heart" />
                <h3>МИ НА ЗВ'ЯЗКУ ДЛЯ ВАС</h3>
                <hr />
                <br />
                <p>
                  Є питання щодо замовлення, доставки чи співпраці?
                  <br />
                  Напишіть нам — з радістю допоможемо ♡
                </p>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 20 }}>
                  <a
                    href="https://www.instagram.com/zori.place.stickers?igsh=dTJrNTFzdHoxYWdk"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-primary"
                    style={{ fontSize: "0.8rem", padding: "10px 20px" }}
                  >
                    Instagram
                  </a>
                  <a
                    href="mailto:zori.place1@gmail.com"
                    className="btn-outline"
                    style={{ fontSize: "0.8rem", padding: "9px 20px" }}
                  >
                    Telegram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mini FAQ */}
      <section className="contact-faq">
        <div className="container" style={{ maxWidth: 820 }}>
          <h3>ПОПУЛЯРНІ ЗАПИТАННЯ</h3>
          <div className="contact-faq-list">
            {FAQS.map((f, i) => (
              <div key={i} className="contact-faq-item">
                <button
                  className="contact-faq-q"
                  onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                >
                  {f.q}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    style={{
                      transform: openFaq === i ? "rotate(180deg)" : "none",
                      transition: "transform 0.2s",
                    }}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {openFaq === i && <div className="contact-faq-a">{f.a}</div>}
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Link to="/faq" className="btn-outline">
              Усі питання та відповіді
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
